module.exports = __webpack_public_path__ + "img/2010 winteressen 008.f22e57ef.jpg";